<template>
  <div class="card-unique-date">
    <div
      :style="thumbImage"
      class="thumb-card">
      <slot name="icon"/>
    </div>
    <div class="body-card">
      <h1 class="title">{{ data.name }}</h1>
      <span class="category">TAGS</span>
      <div class="info-card">
        <div>
          <span>Desde</span><br>
          <span>$1,200</span>
        </div>
        <div>
          <span>Fechas</span><br>
          <span>{{ data.totalPresentations }}</span>
        </div>
        <div>
          <span>Próxima fecha</span><br>
          <span>{{ formatDate(startDate).format('L') }}</span>
        </div>
      </div>
      <div
        class="to-event"
        @click="goToEvent(id)">
        <span>CONSULTAR EVENTO <i class="icon-chevron-right"/></span>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  name: 'MtCardNextDate',
  props: {
    data: {
      type: Object,
      required: true
    },
    startDate: {
      type: String,
      default: ''
    },
    id: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      formatDate: moment
    }
  },
  computed: {
    thumbImage () {
      return {
        backgroundImage: 'url(' + this.data.thumbImage + ')'
      }
    },
    getCategory () {
      return this.$store.getters['categories/items']
    }
  },
  methods: {
    goToEvent (idPresentation) {
      /* this.$router.push({ name: 'dateEvent', params: {date: this.data.id} /!* this.formatDate(this.startDate).format('L') *!/ }) */
      this.$router.push({ name: 'dateEvent', params: { id: idPresentation } })
    }
  }
}
</script>

<style lang="scss" scoped>

  .card-unique-date {
    height: 420px;
    width: 280px;
    border-radius: 2px;
    position: relative;
    margin: 0 auto;
    .thumb-card {
      position: relative;
      border-radius: 2px 2px 0 0;
      height: 200px;
      background-position: center;
      background-size: cover;
      .icon-card {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        position: absolute;
        top: 20px;
        left: 20px;
        -webkit-box-shadow: 0 10px 10px 0 rgba(0,0,0,0.16);
        -moz-box-shadow: 0 10px 10px 0 rgba(0,0,0,0.16);
        box-shadow: 0 10px 10px 0 rgba(0,0,0,0.16);
        i {
          @include center-vertically();
          margin: 0 auto;
          color: white;
          font-size: 24px;
        }
      }
    }
    .body-card {
      width: 100%;
      position: relative;
      padding: 16px 20px 18px 20px;
      background-color: white;
      .title {
        @include font-primary(18px, light);
        color: #444444;
        margin: 0 0 9px;
      }
      .category {
        @include font-primary(8px, bold);
        color: #777777;
      }
      .info-card {
        display: flex;
        justify-content: space-between;
        margin-top: 29px;
        margin-bottom: 16px;
        div {
          span{
            @include font-primary(16px, light);
            color: #444444;
            &:not(:last-child) {
              @include font-primary(9px, bold);
              color: #BFBFBF;
            }
          }

        }
      }
      .to-event {
        border-top: 1px solid #EEEEEE;
        padding-top: 17px;
        text-align: center;
        width: 100%;
        cursor: pointer;
        span{
          @include font-primary(11px, bold);
          color: #777777;
          position: relative;
          &:hover{
            color: black;
          }
          i{
            position: absolute;
            top: 3.4px;
            font-weight: bold;
            color: $roseHeader;
          }
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/_shared/mt-card-next-date.vue